// extracted by mini-css-extract-plugin
module.exports = {"linksWrap":"Header_linksWrap__2DuL_","link":"Header_link__1Wcok","tab":"Header_tab__3iC3E","disabled":"Header_disabled__1YOAc"};